/* tslint:disable */
/* eslint-disable */
/**
 * Vantis.HR.HttpApi.Host
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, BaseAPI } from '../base';
/**
 * CultureApi - axios parameter creator
 * @export
 */
export const CultureApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [module]
         * @param {string} [resoureKey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processApiCultureDeleteCulturePost: async (module, resoureKey, options = {}) => {
            const localVarPath = `/process/api/Culture/DeleteCulture`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (module !== undefined) {
                localVarQueryParameter['module'] = module;
            }
            if (resoureKey !== undefined) {
                localVarQueryParameter['resoureKey'] = resoureKey;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processApiCultureGetAllCultureGet: async (options = {}) => {
            const localVarPath = `/process/api/Culture/GetAllCulture`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processApiCultureGetCultureGet: async (options = {}) => {
            const localVarPath = `/process/api/Culture/GetCulture`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processApiCultureUpsertCulturePost: async (body, options = {}) => {
            const localVarPath = `/process/api/Culture/UpsertCulture`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers?.['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CultureApi - functional programming interface
 * @export
 */
export const CultureApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} [module]
         * @param {string} [resoureKey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processApiCultureDeleteCulturePost(module, resoureKey, options) {
            const localVarAxiosArgs = await CultureApiAxiosParamCreator(configuration).processApiCultureDeleteCulturePost(module, resoureKey, options);
            return (axios = globalAxios, basePath = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processApiCultureGetAllCultureGet(options) {
            const localVarAxiosArgs = await CultureApiAxiosParamCreator(configuration).processApiCultureGetAllCultureGet(options);
            return (axios = globalAxios, basePath = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processApiCultureGetCultureGet(options) {
            const localVarAxiosArgs = await CultureApiAxiosParamCreator(configuration).processApiCultureGetCultureGet(options);
            return (axios = globalAxios, basePath = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processApiCultureUpsertCulturePost(body, options) {
            const localVarAxiosArgs = await CultureApiAxiosParamCreator(configuration).processApiCultureUpsertCulturePost(body, options);
            return (axios = globalAxios, basePath = BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * CultureApi - factory interface
 * @export
 */
export const CultureApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {string} [module]
         * @param {string} [resoureKey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processApiCultureDeleteCulturePost(module, resoureKey, options) {
            return CultureApiFp(configuration).processApiCultureDeleteCulturePost(module, resoureKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processApiCultureGetAllCultureGet(options) {
            return CultureApiFp(configuration).processApiCultureGetAllCultureGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processApiCultureGetCultureGet(options) {
            return CultureApiFp(configuration).processApiCultureGetCultureGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processApiCultureUpsertCulturePost(body, options) {
            return CultureApiFp(configuration).processApiCultureUpsertCulturePost(body, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CultureApi - object-oriented interface
 * @export
 * @class CultureApi
 * @extends {BaseAPI}
 */
export class CultureApi extends BaseAPI {
    /**
     *
     * @param {string} [module]
     * @param {string} [resoureKey]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CultureApi
     */
    async processApiCultureDeleteCulturePost(module, resoureKey, options) {
        return CultureApiFp(this.configuration).processApiCultureDeleteCulturePost(module, resoureKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CultureApi
     */
    async processApiCultureGetAllCultureGet(options) {
        return CultureApiFp(this.configuration).processApiCultureGetAllCultureGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CultureApi
     */
    async processApiCultureGetCultureGet(options) {
        return CultureApiFp(this.configuration).processApiCultureGetCultureGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CultureApi
     */
    async processApiCultureUpsertCulturePost(body, options) {
        return CultureApiFp(this.configuration).processApiCultureUpsertCulturePost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
